export class EksternBrugerAktiverPublicModel {
        public name: string;
        public invitationsPublicId: string;
        public password: string;
        public passwordConfirmed: string;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EksternBrugerAktiverPublicModel.ts